import React from 'react';

import {components, OptionProps} from 'react-select';
import styled from 'styled-components';

import {colors, font} from 'theme';

import {CustomsRow} from 'types/profile';

const Label = styled.div<{isSelected?: boolean}>`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey1)};
    margin-bottom: 4px;
`;
const Number = styled.div<{isSelected?: boolean}>`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey2)};
`;

export const CustomsOption = (props: OptionProps<any, false>) => {
    const {data} = props;
    const itemData: {raw: CustomsRow} = {...data};
    return (
        <components.Option {...props}>
            <Label isSelected={props.isSelected}>{itemData.raw.name}</Label>
            <Number isSelected={props.isSelected}>{itemData.raw.number}</Number>
        </components.Option>
    );
};
